export const sqTranslations = {
  common: {
    create: 'Krijo',
    creating: 'Duke krijuar...',
    loading: 'Duke ngarkuar...',
    save: 'Ruaj',
    saving: 'Duke ruajtur...',
    cancel: 'Anulo',
    delete: 'Fshi',
    edit: 'Ndrysho',
    success: 'Sukses',
    error: 'Gabim',
    confirm: 'Konfirmo',
    search: 'Kërko',
    filter: 'Filtro',
    filterByStatus: 'Filtro sipas Statusit',
    selectStatus: 'Zgjidh statusin',
    showing: 'Duke treguar',
    results: 'rezultate',
    all: 'Të gjitha',
    active: 'Aktiv',
    inactive: 'Joaktiv',
    actions: 'Veprime',
    manual: 'Hyrje Manuale',
    aiGenerate: 'Gjenero me AI',
    plan: 'Plani',
    name: 'Emri',
    type: 'Lloji',
    description: 'Përshkrimi',
    difficulty: 'Vështirësia',
    status: 'Statusi',
    openMenu: 'Hap Menunë',
    method: 'Metoda',
    amount: 'Shuma',
    previous: 'Mëparshme',
    next: 'Tjetër',
    pageInfo:
      'Faqja {{currentPage}} nga {{totalPages}} ({{totalItems}} artikuj)',
    noResults: 'Nuk u gjetën rezultate',
    pleaseFixErrors: 'Ju lutemi rregulloni gabimet para se të dorëzoni',
    noActiveGym: 'Nuk është zgjedhur asnjë palestër aktive',
    errorOccurred: 'Ndodhi një gabim',
    submit: 'Dërgo',
    close: 'Mbyll',
    deleting: 'Duke fshirë...',
    columns: 'Kolonat',
    rows: 'rreshta',
    ofTotal: 'nga',
    selectedUser: 'Përdoruesi i Zgjedhur',
    assigning: 'Duke caktuar...',
    planName: 'Emri i Planit',
    viewAll: 'Shiko të gjitha',
    phone: 'Telefon',
    optional: 'Opsionale',
  },
  qrCode: {
    title: 'Kodi QR i Hyrjes',
    description: 'Gjenero një kod QR për {{userName}} për të hyrë shpejt',
    generating: 'Duke gjeneruar kodin QR...',
    tryAgain: 'Provo Përsëri',
    scanInstructions: 'Skano këtë kod QR për të hyrë shpejt',
    regenerateButton: 'Rigjeneroni Kodin QR',
    regenerate: 'Rigjeneroni',
    errorInvalidResponse:
      'Dështoi gjenerimi i kodit QR: Përgjigje e pavlefshme',
    errorGeneral: 'Dështoi gjenerimi i kodit QR',
    generateLoginQR: 'Gjenero QR për Hyrje',
    expirationInfo: 'Ky kod QR do të skadojë në {{minutes}} minuta',
  },
  sidebar: {
    title: 'Gym',
    dashboard: 'Paneli',
    users: 'Përdoruesit',
    plans: 'Planet',
    payments: 'Pagesat',
    dietPlans: 'Planet Ushqimore',
    exercisePlans: 'Planet e Stërvitjes',
    planAssignments: 'Caktimet e Planeve',
    gyms: 'Palestrat',
    staff: 'Stafi',
    classes: 'Klasat',
    reviews: 'Vlerësimet',
    news: 'Lajme & Oferta',
    chat: 'Mbështetje Chat',
    checkIn: 'Hyrje/Dalje',
    trainers: 'Trajnerët',
    profile: 'Profili',
    appointments: 'Takimet',
    financialReports: 'Raportet Financiare',
    billing: 'Faturimi',
  },
  classes: {
    title: 'Klasat',
    createClass: 'Krijo Klasë',
    editClass: 'Ndrysho Klasën',
    deleteClass: 'Fshi Klasën',
    addClass: 'Shto Klasë',
    className: 'Emri i Klasës',
    classLabel: 'Etiketa e Klasës',
    timeSlots: 'Oraret',
    addTimeSlots: 'Shto Orare',
    editTimeSlot: 'Ndrysho Orarin',
    deleteTimeSlot: 'Fshi Orarin',
    startTime: 'Ora e Fillimit',
    endTime: 'Ora e Mbarimit',
    time: 'Ora',
    type: 'Lloji',
    maxParticipants: 'Pjesëmarrës Maksimalë',
    disabled: 'Çaktivizuar',
    seriesId: 'ID e Serisë',
    bookedCount: 'Të Rezervuara',
    availableSpots: 'Të Disponueshme',
    isFull: 'E Plotë',
    bookings: 'Rezervimet',
    fullName: 'Emri i Plotë',
    phoneNumber: 'Numri i Telefonit',
    status: 'Statusi',
    active: 'Aktiv',
    cancelled: 'Anuluar',
    cancelBooking: 'Anulo Rezervimin',
    classCreated: 'Klasa u krijua me sukses',
    classUpdated: 'Klasa u përditësua me sukses',
    classDeleted: 'Klasa u fshi me sukses',
    timeSlotsAdded: 'Oraret u shtuan me sukses',
    timeSlotUpdated: 'Orari u përditësua me sukses',
    bookingCreated: 'Rezervimi u krijua me sukses',
    bookingCancelled: 'Rezervimi u anulua me sukses',
    confirmDeleteClass: 'Jeni i sigurt që dëshironi të fshini këtë klasë?',
    confirmDeleteTimeSlot: 'Jeni i sigurt që dëshironi të fshini këtë orar?',
    confirmCancelBooking:
      'Jeni i sigurt që dëshironi të anuloni këtë rezervim?',
    noClasses: 'Nuk u gjetën klasa',
    noTimeSlots: 'Nuk ka orare të disponueshme',
    noBookings: 'Nuk u gjetën rezervime',
    capacity: 'Kapaciteti',
    sameCapacityForAll: 'I njëjti kapacitet për të gjitha oraret',
    generateSlots: 'Gjenero Orare',
    slotStartTime: 'Ora e Fillimit të Orarit',
    slotEndTime: 'Ora e Mbarimit të Orarit',
    addSlot: 'Shto Orar',
    removeSlot: 'Hiq Orarin',
    isActive: 'Aktiv',
    viewBookings: 'Shiko Rezervimet',
    manageTimeSlots: 'Menaxho Oraret',
    applyEveryDay: 'Apliko Çdo Ditë (Përsëritës)',
    specificDate: 'Data Specifike',
    recurring: 'Përsëritës',
    oneTime: 'Një herë',
    selectDate: 'Zgjidh Datën',
    disableDate: 'Çaktivizo në Datë Specifike (Opsionale)',
    disableDateHint:
      'Kjo do të çaktivizojë orarin vetëm në këtë datë specifike',
    // Staff & Scheduling
    defaultInstructor: 'Instruktori Parazgjedhur',
    instructor: 'Instruktor',
    schedule: 'Orari',
    daysOfWeek: 'Ditët e Javës',
    blackoutDates: 'Datat e Mbyllura',
    addBlackoutDate: 'Shto Datë të Mbyllur',
    removeBlackoutDate: 'Hiq Datën',
    specificDaysOfWeek: 'Ditë specifike të javës',
    monday: 'E Hënë',
    tuesday: 'E Martë',
    wednesday: 'E Mërkurë',
    thursday: 'E Enjte',
    friday: 'E Premte',
    saturday: 'E Shtunë',
    sunday: 'E Diel',
    classSchedule: 'Orari i Klasës',
    useClassDefault: 'Përdor parazgjedhjen e klasës',
    overridesDefault: 'Mbivendos orarin parazgjedhur të klasës',
    defaultInstructorHint: 'Ky instruktor do të caktohet në të gjitha oraret si parazgjedhje',
    classScheduleHint: 'Nëse është bosh, përdor cilësimet në nivel orari',
    instructorOverrideHint: 'Lini bosh për të përdorur instruktorin parazgjedhur të klasës',
    repeatSchedule: 'Orari i Përsëritjes',
    everyDay: 'Çdo Ditë',
    specificDateOnly: 'Vetëm datë specifike',
    priorityNote: 'Prioriteti: Data specifike > Ditët e javës > Çdo ditë',
    blackoutDatesHint: 'Klasa nuk do të jetë e disponueshme në këto data',
    noBlackoutDates: 'Asnjë datë e mbyllur',
    blackoutDateAdded: 'Data e mbyllur u shtua',
    blackoutDateRemoved: 'Data e mbyllur u hoq',
    editClassDescription: 'Përditëso cilësimet dhe orarin e klasës',
    selectInstructor: 'Zgjidh instruktor...',
    noInstructor: 'Asnjë instruktor',
    notSet: 'Nuk është caktuar',
    selectAll: 'Zgjidh të Gjitha',
    clearAll: 'Pastro të Gjitha',
    allDaysSelected: 'Të gjitha ditët e zgjedhura (çdo ditë)',
    selectDaysHint: 'Zgjidh ditët kur ky orar është i disponueshëm',
    specificDateNote: 'Nëse vendoset, ky orar do të jetë i disponueshëm vetëm në këtë datë specifike',
  },
  planAssignments: {
    title: 'Caktimet e Planeve',
    description: 'Cakto plane stërvitjeje dhe ushqimore për përdoruesit',
    trainingPlans: 'Planet e Stërvitjes',
    dietPlans: 'Planet Ushqimore',
    trainingPlansDescription: 'Cakto plane stërvitjeje për përdoruesit',
    dietPlansDescription: 'Cakto plane ushqimore për përdoruesit',
    assignPlans: 'Cakto Planet',
    viewAssignments: 'Shiko Caktimet',
    selectUser: 'Zgjidh Përdoruesin',
    selectUserDescription: "Zgjidh një përdorues për t'i caktuar një plan",
    selectTrainingPlan: 'Zgjidh Plan Stërvitjeje',
    selectDietPlan: 'Zgjidh Plan Ushqimor',
    selectTrainingPlanDescription: 'Zgjidh një plan stërvitjeje për ta caktuar',
    selectDietPlanDescription: 'Zgjidh një plan ushqimor për ta caktuar',
    searchUsers: 'Kërko përdoruesit',
    searchPlans: 'Kërko planet',
    searchAssignments: 'Kërko caktimet',
    noUsersFound: 'Nuk u gjetën përdorues',
    noPlansFound: 'Nuk u gjetën plane',
    noAssignments: 'Nuk u gjetën caktime',
    assignPlan: 'Cakto Planin',
    assignDietPlan: 'Cakto Planin e Dietës',
    assignExercisePlan: 'Cakto Planin e Ushtrimeve',
    assignPlanDescription: 'Cakto {planName} për një përdorues',
    selectUserRequired:
      "Ju lutemi zgjidhni një përdorues për t'i caktuar planin",
    planAssignedSuccess: '{planName} i është caktuar {userName}',
    assign: 'Cakto',
    planAssigned: 'Plani u caktua me sukses',
    assignmentDeleted: 'Caktimi u fshi me sukses',
    statusUpdated: 'Statusi u përditësua me sukses',
    selectUserAndPlan: 'Ju lutemi zgjidhni si përdoruesin ashtu edhe planin',
    startDate: 'Data e Fillimit',
    endDate: 'Data e Mbarimit',
    statusActive: 'Aktiv',
    statusCompleted: 'Përfunduar',
    statusCancelled: 'Anuluar',
    markActive: 'Shëno si Aktiv',
    markCompleted: 'Shëno si Përfunduar',
    markCancelled: 'Shëno si Anuluar',
    assignedUsers: 'Përdoruesit e caktuar',
    noAssignedUsers: 'Nuk ka përdorues të caktuar për këtë plan',
    planName: 'Emri i planit',
    removeUser: 'Hiq përdoruesin',
  },
  auth: {
    login: 'Hyr',
    loginDescription: 'Hyni në llogarinë tuaj',
    loginButton: 'Hyr',
    register: 'Regjistrohu',
    registerDescription: 'Krijo një llogari të re',
    registerButton: 'Regjistrohu',
    logout: 'Dil',
    email: 'Email',
    password: 'Fjalëkalimi',
    confirmPassword: 'Konfirmo Fjalëkalimin',
    forgotPassword: 'Harruat fjalëkalimin?',
    rememberMe: 'Më mbaj mend',
    loginError: 'Email ose fjalëkalim i pavlefshëm',
    noAccount: 'Nuk keni një llogari?',
    alreadyHaveAccount: 'Keni tashmë një llogari?',
    userType: 'Lloji i Përdoruesit',
    userTypes: {
      admin: 'Administrator',
      staff: 'Anëtar Stafi',
      trainer: 'Trajner',
      user: 'Përdorues i Rregullt',
    },
    passwordsDoNotMatch: 'Fjalëkalimet nuk përputhen',
    // Registration form fields
    firstName: 'Emri',
    lastName: 'Mbiemri',
    phone: 'Numri i Telefonit',
    selectPlan: 'Zgjidhni Planin',
    selectGym: 'Zgjidhni Palestrën',
    // Registration page content
    joinGym: 'Bashkohuni me {{name}} Sot',
    fitnessJourney:
      'Filloni udhëtimin tuaj të fitnesit me anëtarësinë tonë premium. Zgjidhni planin tuaj dhe filloni brenda disa minutash.',
    registrationStep: 'Regjistrimi',
    paymentStep: 'Pagesa',
    completeStep: 'Përfundim',
    personalInfo: 'Informacioni Personal',
    personalInfoDesc: 'Plotësoni të dhënat tuaja bazë',
    membershipDetails: 'Detajet e Anëtarësisë',
    choosePlan: 'Zgjidhni planin dhe palestrën tuaj',
    continueToPayment: 'Vazhdo në Pagesë',
    settingUpPayment: 'Duke konfiguruar pagesën...',
    month: 'muaj',
    // Plan details
    planFeatures: 'Karakteristikat e Planit',
    planBenefits: 'Përfitimet',
    instantActivation: 'Aktivizim i menjëhershëm',
    accessImmediately: 'Qasje menjëherë pas pagesës',
    securePayment: 'Pagesë e Sigurt',
    sslEncryption: 'Enkriptim 256-bit SSL',
    noHiddenFees: 'Pa Tarifa të Fshehura',
    seeWhatYouPay: 'Ajo që shihni është ajo që paguani',
    // Payment
    completeRegistration: 'Përfundo Regjistrimin',
    processing: 'Duke përpunuar...',
    // Success
    registrationComplete: 'Regjistrimi i Përfunduar!',
    welcomeToGym: 'Mirë se erdhët në Gym! Anëtarësia juaj është aktivizuar.',
    redirectingToLogin: 'Do të ridrejtoheni në faqen e hyrjes...',
    nextSteps: 'Hapat e ardhshëm:',
    downloadAppMessage:
      'Shkarkoni aplikacionin Gym dhe identifikohuni atje për të aksesuar palestrën.',
    visitGymMessage:
      'Vizitoni palestrën tuaj me një ID të vlefshëm dhe kodin QR nga aplikacioni mobil.',
    downloadApp: 'Shkarkoni Aplikacionin Gym',
    downloadOn: 'Shkarkoni në',
    getItOn: 'Merreni në',
    goToLogin: 'Shko në Hyrje',
    signIn: 'Identifikohuni këtu',
    backToRegistration: 'Kthehu te Detajet e Regjistrimit',
    selectedPlan: 'Plani juaj i zgjedhur',
    per: 'për',
    daysPerMonth: 'ditë në muaj',
    fullGymAccess: 'Qasje e plotë në palestër',
    groupClassesIncluded: 'Klasat grupore të përfshira',
    noPlansAvailable: 'Nuk ka plane të disponueshme për këtë palestër',
    selectGymFirst:
      'Ju lutemi zgjidhni palestrën tuaj së pari për të parë planet e disponueshme.',
    selectGymAndPlan:
      'Zgjidhni palestrën dhe planin tuaj, pastaj plotësoni të dhënat tuaja.',
    // Payment translations
    payment: {
      orderSummary: 'Përmbledhje e Porosisë',
      membershipPlan: 'Plan Anëtarësie',
      total: 'Totali',
      instantActivation: 'Aktivizim i menjëhershëm pas përfundimit të pagesës',
      paymentInformation: 'Informacioni i Pagesës',
      securePaymentDescription:
        'Pagesa juaj sigurohet nga Stripe. Ne nuk ruajmë kurrë detajet e kartës suaj.',
      cardDetails: 'Detajet e kartës',
      securePayment:
        'Informacioni i pagesës tuaj është i enkriptuar dhe i sigurt',
      processing: 'Duke përpunuar...',
      completeRegistration: 'Përfundo Regjistrimin',
      termsAgreement:
        'Duke përfunduar këtë pagesë, ju pranoni Kushtet e Shërbimit dhe Politikën e Privatësisë.',
      poweredByStripe: 'Mbështetur nga Stripe',
      securePaymentTitle: 'Pagesë e Sigurt',
      sslEncryption: 'Enkriptim 256-bit SSL',
      instantActivationTitle: 'Aktivizim i Menjëhershëm',
      accessImmediately: 'Qasje menjëherë pas pagesës',
      noHiddenFees: 'Pa Tarifa të Fshehura',
      whatYouSee: 'Ajo që shihni është ajo që paguani',
      invalidCardDetails: 'Detajet e kartës janë të pavlefshme',
      invalidCardDetailsTitle: 'Detajet e Kartës të Pavlefshme',
      checkCardInfo: 'Ju lutemi kontrolloni informacionin e kartës suaj',
      registrationComplete: 'Regjistrimi i Përfunduar!',
      welcomeMessage:
        'Anëtarësia juaj është aktivizuar. Mirë se erdhët në Gym!',
      registrationFailed: 'Regjistrimi Dështoi',
      unexpectedError: 'Ndodhi një gabim i papritur',
      userAlreadyExists: 'Përdoruesi me këtë email ekziston tashmë',
      completePayment: 'Përfundo Pagesën',
      paymentDescription:
        'Shkruani detajet e pagesës për të përfunduar regjistrimin tuaj në Gym.',
      paymentSummary: 'Përmbledhje e Pagesës',
    },
    // Errors
    fieldRequired: 'Kjo fushë është e detyrueshme',
    invalidEmail: 'Adresa e email-it nuk është e vlefshme',
    passwordTooShort: 'Fjalëkalimi duhet të jetë të paktën 6 karaktere',
    registrationFailed: 'Regjistrimi Dështoi',
    somethingWentWrong: 'Diçka shkoi keq',
    // Multi-tenancy
    tenant: {
      contextNotSet: 'Ju lutemi zgjidhni një palestrë para se të vazhdoni',
      accessDenied: 'Nuk keni qasje në këtë palestrë',
      notFound: 'Palestra e zgjedhur nuk u gjet',
      inactive: 'Palestra e zgjedhur është aktualisht joaktive',
      switchNotAllowed: 'Ndërrimi i palestrës nuk lejohet për këtë aplikacion',
    },
  },
  dashboard: {
    title: 'Paneli',
    welcome: 'Mirë se u kthyet',
    totalUsers: 'Totali i Përdoruesve',
    activeUsers: 'Përdoruesit Aktivë',
    totalRevenue: 'Të Ardhurat Totale',
    activeGyms: 'Palestrat Aktive',
    activeSubscriptions: 'Abonimet Aktive',
    revenueThisMonth: 'Të ardhurat këtë muaj',
    recentUsers: 'Përdoruesit e Fundit',
    recentPayments: 'Pagesat e Fundit',
    viewAll: 'Shiko të gjitha',
    gymSelector: 'Zgjidh Palestrën',
    selectGym: 'Zgjidhni palestrën',
    allGyms: 'Të gjitha Palestrat',
    totalUsersAtGym: 'Totali i Përdoruesve në {{gym}}',
    activeUsersAtGym: 'Përdoruesit Aktivë në {{gym}}',
    totalRevenueAtGym: 'Të Ardhurat Totale në {{gym}}',
    noGymTitle: 'Nuk u gjet asnjë palestër',
    noGymDescription:
      'Ju ende nuk keni asnjë palestër. Krijoni palestrën tuaj të parë për të filluar.',
    createGymNow: 'Krijo Palestër Tani',
    createGymInstructions:
      'Për të filluar, krijoni palestrën tuaj të parë duke klikuar butonin më poshtë.',
    noRecentUsers: 'Nuk ka përdorues të fundit',
    noRecentPayments: 'Nuk ka pagesa të fundit',
    noActivePlans: 'Nuk ka plane aktive',
    plansActive: 'Planet janë aktive',
  },
  users: {
    title: 'Përdoruesit',
    addUser: 'Shto Përdorues',
    editUser: 'Ndrysho Përdoruesin',
    deleteUser: 'Fshi Përdoruesin',
    userDetails: 'Detajet e Përdoruesit',
    usersList: 'Lista e Përdoruesve',
    name: 'Emri',
    firstName: 'Emri',
    lastName: 'Mbiemri',
    email: 'Email',
    phone: 'Telefoni',
    status: 'Statusi',
    joinDate: 'Data e Regjistrimit',
    remaining: 'Të mbetura',
    expirationDate: 'Data e Skadimit',
    address: 'Adresa',
    city: 'Qyteti',
    country: 'Shteti',
    subscriptions: 'Abonimet',
    payments: 'Pagesat',
    confirmDelete: 'Jeni i sigurt që dëshironi të fshini këtë përdorues?',
    userDeleted: 'Përdoruesi u fshi me sukses',
    userAdded: 'Përdoruesi u shtua me sukses',
    userUpdated: 'Përdoruesi u përditësua me sukses',
    addUserDescription: 'Shto një përdorues të ri në sistem',
    editUserDescription: 'Ndrysho informacionin e përdoruesit',
    active: 'Aktiv',
    inactive: 'Joaktiv',
    search: 'Kërko përdorues',
    assignGyms: 'Cakto Palestrat',
    addFailed: 'Dështoi shtimi i përdoruesit',
    noUsers: 'Nuk u gjetën përdorues',
    userNotFound: 'Përdoruesi nuk u gjet',
    saveChanges: 'Ruaj Ndryshimet',
    view: 'Shiko',
    details: 'Detajet',
    dietPlans: 'Planet e Dietës',
    exercisePlans: 'Planet e Ushtrimeve',
    userDietPlans: 'Planet e Dietës së Përdoruesit',
    userExercisePlans: 'Planet e Ushtrimeve të Përdoruesit',
    userPayments: 'Pagesat e Përdoruesit',
    partiallyPaidOnly: 'Vetëm Pjesërisht të Paguara',
    filterPartiallyPaid: 'Filtro përdoruesit me status pjesërisht të paguar',
    noDietPlans: 'Nuk ka plane diete të caktuara',
    noExercisePlans: 'Nuk ka plane ushtrimesh të caktuara',
    noPayments: 'Nuk u gjetën pagesa',
    activePlan: 'Plani Aktiv',
    activePlans: 'Planet Aktive',
    noActivePlans: 'Nuk ka plane aktive',
    startDate: 'Data e Fillimit',
    endDate: 'Data e Mbarimit',
    fixedPlan: 'Plan Fiks',
    checkInHistory: 'Historia e Hyrjeve',
  },
  trainers: {
    title: 'Trajnerët',
    addTrainer: 'Shto Trajner',
    editTrainer: 'Ndrysho Trajnerin',
    deleteTrainer: 'Fshi Trajnerin',
    trainerDetails: 'Detajet e Trajnerit',
    trainersList: 'Lista e Trajnerëve',
    name: 'Emri',
    email: 'Email',
    phone: 'Telefoni',
    specialization: 'Specializimi',
    clients: 'Klientët',
    joinDate: 'Data e Regjistrimit',
    status: 'Statusi',
    schedule: 'Orari',
    certifications: 'Certifikimet',
    confirmDelete: 'Jeni i sigurt që dëshironi të fshini këtë trajner?',
    trainerDeleted: 'Trajneri u fshi me sukses',
    trainerAdded: 'Trajneri u shtua me sukses',
    trainerUpdated: 'Trajneri u përditësua me sukses',
    addTrainerDescription: 'Shto një trajner të ri në sistem',
    editTrainerDescription: 'Ndrysho informacionin e trajnerit',
  },
  appointments: {
    title: 'Takimet',
    addAppointment: 'Shto Takim',
    editAppointment: 'Ndrysho Takimin',
    deleteAppointment: 'Fshi Takimin',
    appointmentDetails: 'Detajet e Takimit',
    appointmentsList: 'Lista e Takimeve',
    client: 'Klienti',
    trainer: 'Trajneri',
    date: 'Data',
    time: 'Koha',
    duration: 'Kohëzgjatja',
    status: 'Statusi',
    notes: 'Shënime',
    confirmDelete: 'Jeni i sigurt që dëshironi të fshini këtë takim?',
    appointmentDeleted: 'Takimi u fshi me sukses',
    appointmentAdded: 'Takimi u shtua me sukses',
    appointmentUpdated: 'Takimi u përditësua me sukses',
    addAppointmentDescription: 'Planifiko një takim të ri',
    editAppointmentDescription: 'Ndrysho detajet e takimit',
    confirmed: 'Konfirmuar',
    pending: 'Në pritje',
    cancelled: 'Anuluar',
    noAppointments: 'Nuk ka takime për këtë ditë',
    selectClient: 'Zgjidh klientin',
    selectTrainer: 'Zgjidh trajnerin',
    pickDate: 'Zgjidh një datë',
    selectTime: 'Zgjidh kohën',
    notesPlaceholder: 'Shto shënime për këtë takim',
    appointmentsFor: 'Takimet për',
    calendarDescription: 'Shiko dhe menaxho takimet',
  },
  plans: {
    title: 'Planet',
    fixed: 'Pa skadencë',
    description: 'Menaxhoni planet e anëtarësimit në palestër',
    addPlan: 'Shto Plan',
    editPlan: 'Ndrysho Planin',
    deletePlan: 'Fshi Planin',
    addPlanDescription: 'Shto një plan të ri anëtarësimi në palestrën tënde',
    editPlanDescription: 'Ndrysho detajet e këtij plani anëtarësimi',
    deletePlanDescription: 'A jeni i sigurt që dëshironi të fshini këtë plan?',
    name: 'Emri',
    price: 'Çmimi',
    duration: 'Kohëzgjatja',
    durationType: 'Lloji i Kohëzgjatjes',
    days: 'Ditë',
    day: 'Ditë',
    months: 'Muaj',
    month: 'Muaj',
    years: 'Vite',
    year: 'Vit',
    descriptionLabel: 'Përshkrimi',
    status: 'Statusi',
    active: 'Aktiv',
    inactive: 'Joaktiv',
    currency: 'Valuta',
    selectCurrency: 'Zgjidhni valutën',
    filterByName: 'Filtro sipas emrit...',
    noPlans: 'Nuk u gjetën plane',
    planAdded: 'Plani u shtua me sukses',
    planUpdated: 'Plani u përditësua me sukses',
    planDeleted: 'Plani u fshi me sukses',
    errorAddingPlan: 'Gabim gjatë shtimit të planit',
    errorUpdatingPlan: 'Gabim gjatë përditësimit të planit',
    errorDeletingPlan: 'Gabim gjatë fshirjes së planit',
    noGymSelected:
      'Nuk është zgjedhur asnjë palestër. Ju lutemi zgjidhni një palestër së pari.',
    selectGymFirst: 'Ju lutemi zgjidhni një palestër së pari',
    noActivePlans: 'Nuk ka plane aktive',
    deleteConfirmNamed:
      "Jeni i sigurt që dëshironi të fshini planin '{{name}}'?",
    deleteError: 'Gabim gjatë fshirjes së planit',
    assignGyms: 'Cakto në Palestrat',
    selectAtLeastOneGym: 'Ju lutem zgjidhni të paktën një palestër',
    isClass: 'Plan për Klasë',
    isClassDescription: 'Ky plan është për një klasë specifike',
    selectClass: 'Zgjidhni Klasën',
    selectClasses: 'Zgjidhni Klasat',
    selectClassPlaceholder: 'Zgjidhni një klasë',
    noClassesAvailable: 'Nuk ka klasa të disponueshme',
    planAddedSuccessfully: 'Plani u shtua me sukses',
    errorCreatingPlan: 'Gabim gjatë krijimit të planit',
  },
  payments: {
    title: 'Pagesat',
    addPayment: 'Shto Pagesë',
    paymentsList: 'Lista e Pagesave',
    user: 'Përdoruesi',
    amount: 'Shuma',
    date: 'Data',
    method: 'Metoda',
    status: 'Statusi',
    subscription: 'Abonimi',
    transactionId: 'ID e Transaksionit',
    paymentAdded: 'Pagesa u shtua me sukses',
    paymentDeleted: 'Pagesa u fshi me sukses',
    addPaymentDescription: 'Regjistro një pagesë të re',
    paid: 'Paguar',
    pending: 'Në pritje',
    failed: 'Dështuar',
    refunded: 'Rimbursuar',
    partiallyPaid: 'Pjesërisht e Paguar',
    free: 'Falas',
    statusExpired: 'Skaduar',
    freePaymentNote: 'Shuma vendoset automatikisht në 0 për pagesat falas',
    selectUser: 'Zgjidh përdoruesin',
    selectSubscription: 'Zgjidh abonimin',
    // Added missing translations
    plan: 'Plani',
    selectPlan: 'Zgjidh planin',
    noPlansAvailable: 'Nuk ka plane në dispozicion',
    cash: 'Para në dorë',
    creditCard: 'Kartë Krediti',
    confirmDelete: 'Jeni i sigurt që dëshironi të fshini këtë pagesë?',
    noPayments: 'Nuk u gjetën pagesa',
    noPaymentsForStatus: 'Nuk u gjetën pagesa për statusin e zgjedhur',
    // New installment-related translations
    installments: 'Këste',
    addInstallment: 'Shto Këst',
    addInstallmentDescription: 'Shto një këst të ri për këtë pagesë',
    enableInstallments: 'Aktivizo pagesën me këste',
    isOffer: 'Është Ofertë',
    offer: 'Ofertë',
    noInstallments: 'Nuk ka këste të shtuara ende',
    installmentAdded: 'Kësti u shtua me sukses',
    installmentAddError: 'Dështoi të shtojë këst',
    allInstallmentAmounts:
      'Të gjitha shumat e kësteve duhet të jenë të vlefshme',
    totalAmount: 'Shuma Totale',
    paidAmount: 'Shuma e Paguar',
    planAmount: 'Shuma e Planit',
    remainingAmount: 'Shuma e Mbetur',
    totalPaid: 'Totali i Paguar',
    deleteConfirmation: 'Jeni i sigurt që dëshironi të fshini këtë pagesë?',
    singlePayment: 'Pagesë e Vetme',
    details: 'Detajet e Pagesës',
    viewInstallments: 'Shiko Këste',
    // Upgrade feature translations
    upgrade: 'Përmirëso',
    upgradePayment: 'Përmirëso Planin',
    selectNewPlan: 'Zgjidh Plan të Ri',
    noPlansAvailableForUpgrade: 'Nuk ka plane të disponueshme për përmirësim',
    upgraded: 'Pagesa u përmirësua me sukses',
    upgradeError: 'Dështoi përmirësimi i pagesës',
    active: 'Aktiv',
    deleteError: 'Dështoi fshirja e pagesës',
    currentPlan: 'Plani Aktual',
    currentPayment: 'Pagesa Aktuale',
    toPay: 'Për të paguar',
    cannotDowngrade: 'Nuk mund të zvogëlohet në çmim më të ulët',
    // Comparison feature translations
    paymentSummary: 'Përmbledhja e Pagesave',
    selectedPeriod: 'Periudha e Zgjedhur',
    comparisonPeriod: 'Periudha e Krahasimit',
    enableComparison: 'Aktivizo Krahasimin',
    compareWith: 'Krahaso me',
    selectComparisonDateRange: 'Zgjidh intervalin e datave për krahasim',
    // Expired status translations
    expired: 'Skaduar',
    expiredAt: 'Skadoi më',
    expiredReasons: {
      date_expired: 'Data e përfundimit të pagesës ka kaluar',
      entries_exhausted: 'Të gjitha hyrjet janë përdorur',
      manually_expired: 'Skaduar manualisht nga administratori',
    },
  },
  dietPlans: {
    title: 'Diet Plans',
    addPlan: 'Add Diet Plan',
    editPlan: 'Edit Diet Plan',
    deleteDietPlan: 'Delete Diet Plan',
    plansList: 'Diet Plans List',
    name: 'Name',
    type: 'Type',
    calories: 'Calories',
    protein: 'Protein (g)',
    carbs: 'Carbs (g)',
    fat: 'Fat (g)',
    description: 'Description',
    breakfast: 'Breakfast',
    lunch: 'Lunch',
    dinner: 'Dinner',
    snacks: 'Snacks',
    confirmDelete: 'Are you sure you want to delete this diet plan?',
    planDeleted: 'Diet plan deleted successfully',
    planAdded: 'Diet plan added successfully',
    planUpdated: 'Diet plan updated successfully',
    addPlanDescription: 'Add a new diet plan',
    editPlanDescription: 'Edit diet plan details',
  },
  exercisePlans: {
    title: 'Exercise Plans',
    addPlan: 'Add Exercise Plan',
    editPlan: 'Edit Exercise Plan',
    deleteExercisePlan: 'Delete Exercise Plan',
    plansList: 'Exercise Plans List',
    name: 'Name',
    type: 'Type',
    difficulty: 'Difficulty',
    beginner: 'Beginner',
    intermediate: 'Intermediate',
    advanced: 'Advanced',
    duration: 'Duration',
    minutes: 'minutes',
    targetMuscles: 'Target Muscles',
    equipment: 'Equipment',
    description: 'Description',
    exercises: 'Exercises',
    exercise: 'Exercise',
    addExercise: 'Add Exercise',
    removeExercise: 'Remove Exercise',
    exerciseName: 'Exercise Name',
    sets: 'Sets',
    reps: 'Reps',
    rest: 'Rest',
    exerciseDescription: 'Exercise Description',
    confirmDelete: 'Are you sure you want to delete this exercise plan?',
    planDeleted: 'Exercise plan deleted successfully',
    planAdded: 'Exercise plan added successfully',
    planUpdated: 'Exercise plan updated successfully',
    addPlanDescription: 'Add a new exercise plan',
    editPlanDescription: 'Edit exercise plan details',
    noPlans: 'Nuk u gjetën plane ushtrimesh',
  },
  gyms: {
    title: 'Gyms',
    gymsList: 'Gyms List',
    addGym: 'Add Gym',
    editGym: 'Edit Gym',
    deleteGym: 'Delete Gym',
    name: 'Name',
    address: 'Address',
    city: 'City',
    country: 'Country',
    phone: 'Phone',
    email: 'Email',
    workingHours: 'Working Hours',
    facilities: 'Facilities',
    status: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    selectStatus: 'Select status',
    addGymDescription: 'Add a new gym to your network',
    editGymDescription: 'Edit gym details',
    deleteConfirm:
      'Are you sure you want to delete this gym? This action cannot be undone.',
    gymAdded: 'Gym added successfully',
    gymUpdated: 'Gym updated successfully',
    gymDeleted: 'Gym deleted successfully',
    errorAddingGym: 'Error adding gym',
    errorUpdatingGym: 'Error updating gym',
    errorDeletingGym: 'Error deleting gym',
    errorFetchingGym: 'Error fetching gym details',
    errorFetchingGyms: 'Error fetching gyms',
    noGyms: 'No gyms found',
    gymUsage: '{{current}} nga {{limit}} palestra të përdorura',
    gymLimitReached: 'Limiti i palestrave u arrit',
    gymLimitReachedMessage:
      'Keni arritur limitin e palestrave. Ju lutemi përmirësoni abonimin tuaj për të shtuar më shumë palestra.',
    upgradeSubscription: 'Përmirëso Abonimin',
  },
  staff: {
    title: 'Staff Management',
    addStaff: 'Add Staff Member',
    addStaffDescription: 'Add a new staff member to your gym',
    editStaff: 'Edit Staff Member',
    editStaffDescription: 'Edit staff member details',
    deleteStaff: 'Delete Staff Member',
    deleteStaffDescription:
      'Are you sure you want to delete this staff member?',
    deleteStaffConfirm: 'Yes, delete staff member',
    staffDeleted: 'Staff member deleted successfully',
    staffAdded: 'Staff member added successfully',
    staffUpdated: 'Staff member updated successfully',
    addFailed: 'Failed to add staff member',
    updateFailed: 'Failed to update staff member',
    deleteFailed: 'Failed to delete staff member',
    fillRequiredFields: 'Please fill all required fields',
    selectAtLeastOneGym: 'Please select at least one gym',
    noStaff: 'No staff members found',
    noSearchResults: 'No staff members match your search',
    errorLoading: 'Error loading staff members',
    name: 'Name',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    phone: 'Phone',
    position: 'Position',
    gym: 'Gym',
    hireDate: 'Hire Date',
    status: 'Status',
    address: 'Adresa',
    certifications: 'Certifikimet',
    workingHours: 'Working Hours',
    confirmDelete: 'Are you sure you want to delete this staff member?',
    active: 'Active',
    inactive: 'Inactive',
    selectPosition: 'Select position',
    selectGym: 'Select gym',
    certificationsPlaceholder: 'Enter certifications, comma separated',
    search: 'Search staff',
    userType: 'User Type',
    selectUserType: 'Select user type',
    userTypes: {
      admin: 'Administrator',
      reception: 'Receptionist',
      trainer: 'Trainer',
      owner: 'Owner',
    },
    assignGyms: 'Assign to Gyms',
    noGymsAvailable: 'No gyms available',
    deleteError: 'Error deleting staff member',
    cannotDeleteOwner: 'Cannot delete owner',
    deleteConfirmNamed: 'Are you sure you want to delete {{name}}?',
    // Added missing translations
    searchStaff: 'Search staff...',
    staffManagement: 'Staff Management',
    firstNamePlaceholder: 'Enter first name',
    lastNamePlaceholder: 'Enter last name',
    emailPlaceholder: 'Enter email address',
    phonePlaceholder: 'Enter phone number',
  },
  reviews: {
    title: 'Vlerësimet',
    statistics: 'Statistikat',
    allReviews: 'Të gjitha Vlerësimet',
    reviewDetails: 'Detajet e Vlerësimit',
    reviewsList: 'Lista e Vlerësimeve',
    
    // Filters
    filterByGym: 'Filtro sipas Palestres',
    allGyms: 'Të gjitha Palestrat',
    filterByType: 'Filtro sipas Llojit',
    filterByRating: 'Filtro sipas Vlerësimit',
    allTypes: 'Të gjitha Llojet',
    classReviews: 'Vlerësime të Klasave',
    staffReviews: 'Vlerësime të Stafit',
    sessionReviews: 'Vlerësime të Seancave',
    allRatings: 'Të gjitha Vlerësimet',
    fiveStarsOnly: 'Vetëm 5 Yje',
    fourPlusStars: '4+ Yje',
    threePlusStars: '3+ Yje',
    dateRange: 'Intervali i Datave',
    startDate: 'Data e Fillimit',
    endDate: 'Data e Mbarimit',
    clearFilters: 'Pastro Filtrat',
    
    // Table
    date: 'Data',
    member: 'Anëtar',
    anonymous: 'Anonim',
    reviewType: 'Lloji',
    target: 'Objektivi',
    class: 'Klasa',
    instructor: 'Instruktori',
    rating: 'Vlerësimi',
    feedback: 'Koment',
    viewDetails: 'Shiko Detajet',
    user: 'Përdorues',
    gym: 'Palestra',
    comment: 'Komenti',
    
    // Detail Modal
    reviewDetail: 'Detajet e Vlerësimit',
    submittedBy: 'Dorëzuar nga',
    submittedOn: 'Dorëzuar më',
    adminNotes: 'Shënime të Administratorit (Interne)',
    adminNotesPlaceholder: 'Shto shënime të brendshme për këtë vlerësim...',
    saveNotes: 'Ruaj Shënimet',
    archiveReview: 'Arkivo Vlerësimin',
    confirmArchive: 'Jeni i sigurt që dëshironi të arkivoni këtë vlerësim?',
    
    // Stats
    totalReviews: 'Vlerësime Totale',
    averageRating: 'Vlerësimi Mesatar',
    recentTrend: 'Trendi i Fundit (7 ditë)',
    lowRatingsAlert: 'Vlerësime të Ulëta (1-2★)',
    ratingDistribution: 'Shpërndarja e Vlerësimeve',
    topRatedClasses: 'Klasat më të Vlerësuara',
    topRatedStaff: 'Stafi më i Vlerësuar',
    reviewCount: 'vlerësime',
    
    // Messages
    notesSaved: 'Shënimet u ruajtën me sukses',
    reviewArchived: 'Vlerësimi u arkivua me sukses',
    noReviews: 'Nuk u gjetën vlerësime',
    noReviewsForFilter: 'Nuk ka vlerësime që përputhen me filtrat',
    
    // Types
    classReview: 'Vlerësim i Klasës',
    staffReview: 'Vlerësim i Stafit',
    sessionReview: 'Vlerësim i Seancës',
    
    // Legacy (keeping for backwards compatibility)
    status: 'Statusi',
    approve: 'Aprovo',
    reject: 'Refuzo',
    reviewApproved: 'Vlerësimi u aprovua me sukses',
    reviewRejected: 'Vlerësimi u refuzua me sukses',
    approved: 'Aprovuar',
    rejected: 'Refuzuar',
    pending: 'Në pritje',
    search: 'Kërko vlerësime',
  },
  news: {
    title: 'Lajme & Oferta',
    addPost: 'Shto Lajm/Ofertë',
    editNews: 'Edit News/Offer',
    deleteNews: 'Delete News/Offer',
    postsList: 'Posts List',
    titleLabel: 'Titulli',
    content: 'Përmbajtja',
    type: 'Lloji',
    publishDate: 'Data e Publikimit',
    expiryDate: 'Expiry Date',
    status: 'Statusi',
    image: 'Imazhi',
    news: 'Lajm',
    offer: 'Ofertë',
    discount: 'Zbritja',
    discountCode: 'Kodi i Zbritjes',
    confirmDelete: 'Are you sure you want to delete this news/offer?',
    newsDeleted: 'News/offer deleted successfully',
    newsAdded: 'News added successfully',
    newsUpdated: 'News/offer updated successfully',
    addPostDescription: 'Add a new news article or special offer',
    editNewsDescription: 'Edit news article or special offer details',
    active: 'Active',
    inactive: 'Inactive',
    expired: 'Expired',
    postTitle: 'Title',
    search: 'Search news and offers',
  },
  chat: {
    title: 'Chat Support',
    conversations: 'Bisedat',
    noConversations: 'Nuk ka biseda ende',
    noConversationSelected: 'Nuk është zgjedhur asnjë bisedë',
    selectConversation: 'Zgjidh një bisedë për të filluar',
    startConversation: 'Fillo një bisedë',
    send: 'Dërgo',
    typeMessage: 'Shkruaj një mesazh...',
    messageSent: 'Mesazhi u dërgua',
    lastActive: 'Aktiv fundit',
    unreadMessages: 'mesazhe të palexuara',
    newMessages: 'të reja',
  },
  checkIn: {
    title: 'Hyrje/Dalje',
    scan: 'Skano',
    manualEntry: 'Hyrje Manuale',
    generateQrCode: 'Gjenero Kod QR',
    scanQrCode: 'Skano Kodin QR',
    recentActivity: 'Aktiviteti i Fundit',
    checkInHistory: 'Historia e Hyrjeve',
    user: 'Përdoruesi',
    gym: 'Palestra',
    checkInTime: 'Koha e Hyrjes',
    checkOutTime: 'Koha e Daljes',
    status: 'Statusi',
    active: 'Aktiv',
    completed: 'Përfunduar',
    checkIn: 'Hyrje',
    checkOut: 'Dil',
    quickCheckIn: 'Hyr',
    userCheckedIn: 'Përdoruesi hyri me sukses',
    userCheckedOut: 'Përdoruesi doli me sukses',
    generateQR: 'Gjenero Kodin QR',
    scanQR: 'Skano Kodin QR',
    selectUser: 'Zgjidh Përdoruesin',
    selectGym: 'Zgjidh Palestrën',
    duration: 'Kohëzgjatja',
    scanningInstructions: 'Vendosni kodin QR në qendër të skanerit',
    noCheckIns: 'Nuk ka hyrje',
    downloadQrCode: 'Shkarko kodin QR',
    actions: 'Veprime',
  },
  profile: {
    title: 'Profili',
    personalInfo: 'Informacioni Personal',
    changePassword: 'Ndrysho Fjalëkalimin',
    name: 'Emri',
    email: 'Email',
    phone: 'Telefoni',
    address: 'Adresa',
    city: 'Qyteti',
    country: 'Shteti',
    currentPassword: 'Fjalëkalimi Aktual',
    newPassword: 'Fjalëkalimi i Ri',
    confirmPassword: 'Konfirmo Fjalëkalimin',
    updateProfile: 'Përditëso Profilin',
    updatePassword: 'Përditëso Fjalëkalimin',
    profileUpdated: 'Profili u përditësua me sukses',
    passwordUpdated: 'Fjalëkalimi u përditësua me sukses',
    password: 'Password',
    firstName: 'Emri',
    lastName: 'Mbiemri',
  },
  ai: {
    generateDietPlan: 'Gjenero Plan Ushqimor me AI',
    generateExercisePlan: 'Gjenero Plan Stërvitjeje me AI',
    dietPlanDescription:
      'Përshkruaj planin ushqimor që dëshironi të krijoni, duke përfshirë qëllimet, preferencat dhe çdo kufizim.',
    exercisePlanDescription:
      'Përshkruaj planin e stërvitjes që dëshironi të krijoni, duke përfshirë nivelin e fitnesit, qëllimet dhe pajisjet në dispozicion.',
    dietPlanPlaceholder:
      'p.sh., Krijo një plan ushqimor për humbje peshe për një 30-vjeçar me 1800 kalori në ditë, karbohidrate të ulëta, proteinë të lartë...',
    exercisePlanPlaceholder:
      'p.sh., Krijo një program stërvitjeje për forcë për fillestarë me qasje në pajisje bazë palestre...',
    generate: 'Gjenero',
    generating: 'Duke gjeneruar...',
    planGenerated: 'Plani u Gjenerua',
    reviewAndEdit:
      'Ju lutemi rishikoni dhe ndryshoni planin e gjeneruar përpara se ta ruani.',
    generationFailed: 'Dështoi gjenerimi i planit. Ju lutemi provoni përsëri.',
  },
  userView: {
    title: 'Gym',
    welcome: 'Mirë se vini',
    welcomeMessage: 'Mirë se vini në Portalin e Anëtarëve Gym',
    membership: 'Anëtarësia',
    exercisePlans: 'Planet e Stërvitjes',
    dietPlans: 'Planet Ushqimore',
    appointments: 'Takimet',
    chat: 'Chat',
    tabs: {
      membership: 'Anëtarësia',
      appointments: 'Takimet',
      exercise: 'Ushtrime',
      diet: 'Dieta',
      chat: 'Mbështetje',
    },
    notifications: {
      title: 'Njoftimet',
      markAllRead: 'Shëno të gjitha si të lexuara',
      noNotifications: 'Nuk ka njoftime',
      newWorkout: 'Plan i ri stërvitjeje në dispozicion',
      membershipRenewal: 'Rinovimi i anëtarësisë',
      gymHours: 'Orari i palestrës gjatë pushimeve',
      newDietPlan: 'Rekomandim i ri i planit të dietës',
      fitnessChallenge: 'Sfida e fitnesit fillon së shpejti',
      newAppointment: 'Takim i ri me trajnerin u planifikua',
    },
    myMembership: {
      title: 'Anëtarësia Ime',
      activeMembership: 'Anëtarësia Aktive',
      scanToAccess: 'Skano këtë kod QR për të hyrë në palestër',
      active: 'Aktive',
      validUntil: 'E vlefshme deri më {{date}}',
      accessAllGyms: 'Akses në të gjitha lokacionet Gym',
      renewMembership: 'Rinovoni Anëtarësinë',
      membershipHistory: 'Historia e Anëtarësisë',
      past: 'E Kaluar',
      noActiveMemberships: 'Nuk ka anëtarësi aktive',
      noPastMemberships: 'Nuk ka anëtarësi të kaluara',
      startedOn: 'Filloi më {{date}}',
      expired: 'Skadoi më {{date}}',
      renew: 'Rinovoni',
    },
    myAppointments: {
      title: 'Takimet e Mia me Trajnerin',
      upcoming: 'Të ardhshme',
      past: 'Të kaluara',
      with: 'me',
      today: 'Sot',
      completed: 'Përfunduar',
      missed: 'Munguar',
      cancel: 'Anulo Takimin',
      cancelConfirm: 'Jeni i sigurt që dëshironi të anuloni këtë takim?',
      noUpcoming: 'Nuk ka takime të ardhshme',
      noPast: 'Nuk ka takime të kaluara',
      notes: 'Shënime Seance',
    },
    exercise: {
      title: 'Planet e Ushtrimeve',
      generatePlan: 'Gjenero Plan',
      generatePlanDescription:
        'Krijoni një plan të personalizuar ushtrimesh bazuar në qëllimet dhe preferencat tuaja',
      customizeYourPlan: 'Personalizoni planin tuaj të ushtrimeve',
      progress: 'Progresi i Sotëm',
      difficulty: 'Vështirësia',
      minutes: 'min',
      todaysWorkout: 'Stërvitja e Sotme',
      rest: 'Pushim',
      completeWorkout: 'Përfundo Stërvitjen',
      description: 'Përshkrimi',
      targetMuscles: 'Muskujt e Synuar',
      equipment: 'Pajisjet',
      exercises: 'Ushtrimet',
      assignedOn: 'Caktuar Më',
      lastUpdated: 'Përditësuar së Fundmi',
    },
    diet: {
      title: 'Planet e Dietës',
      generatePlan: 'Gjenero Plan',
      generatePlanDescription:
        'Krijoni një plan të personalizuar diete bazuar në qëllimet dhe preferencat tuaja',
      customizeYourPlan: 'Personalizoni planin tuaj të dietës',
      calories: 'Kalori',
      protein: 'Protein',
      carbs: 'Karbohidrate',
      fat: 'Yndyrë',
      mealPlan: 'Plani i Vakteve',
      breakfast: 'Mëngjesi',
      lunch: 'Dreka',
      dinner: 'Darka',
      snacks: 'Zamra',
      trackMeals: 'Gjurmo Vaktet e Sotme',
      assignedOn: 'Caktuar Më',
      lastUpdated: 'Përditësuar së Fundmi',
    },
    supportChat: {
      title: 'Chat Mbështetës',
      supportChat: 'Bisedo me Mbështetjen',
      description: 'Merrni ndihmë nga ekipi ynë',
      typeMessage: 'Shkruani mesazhin tuaj...',
      send: 'Dërgo',
    },
    upcomingAppointments: 'Takimet e Ardhshme',
    appointmentsDescription: 'Shiko takimet e tua të ardhshme me trajnerët',
  },
  header: {
    notifications: 'Njoftimet',
    switchToUser: 'Kalo në Pamjen e Përdoruesit',
    switchToAdmin: 'Kalo në Pamjen e Administratorit',
    switchToTrainer: 'Kalo në Pamjen e Trajnerit',
    adminView: 'Pamja e Administratorit',
    userView: 'Pamja e Përdoruesit',
    trainerView: 'Pamja e Trajnerit',
    language: 'Gjuha',
    english: 'Anglisht',
    albanian: 'Shqip',
    receptionView: 'Pamja e Recepsionit',
    searchUsers: 'Kërko përdorues...',
    noUsersFound: 'Nuk u gjetën përdorues',
  },
  trainerView: {
    title: 'Gym Trajner',
    welcomeMessage: 'Mirë se vini në Portalin e Trajnerëve Gym',
    tabs: {
      calendar: 'Kalendari',
      clients: 'Klientët',
      profile: 'Profili',
    },
    calendar: {
      title: 'Kalendari i Takimeve',
      addAppointment: 'Shto Takim',
      noAppointments: 'Nuk ka takime për këtë ditë',
      appointmentsCount: '{{count}} takime të planifikuara',
      noAppointmentsMessage: 'Nuk ka takime të planifikuara për këtë ditë',
      addAppointmentForDay: 'Shto Takim për {{day}}',
    },
    addAppointment: {
      title: 'Shto Takim',
      description: 'Planifiko një takim të ri për {{date}}',
      client: 'Klienti',
      selectClient: 'Zgjidh një klient',
      startTime: 'Ora e Fillimit',
      endTime: 'Ora e Mbarimit',
      type: 'Lloji',
      selectType: 'Zgjidh llojin e takimit',
      notes: 'Shënime',
      save: 'Ruaj Takimin',
    },
    appointmentDetails: {
      viewTitle: 'Detajet e Takimit',
      editTitle: 'Ndrysho Takimin',
      client: 'Klienti',
      time: 'Ora',
      type: 'Lloji',
      status: 'Statusi',
      notes: 'Shënime',
      noNotes: 'Nuk ka shënime',
      edit: 'Ndrysho',
      save: 'Ruaj Ndryshimet',
      cancel: 'Anulo',
      delete: 'Fshi',
      deleteConfirmTitle: 'Fshi Takimin',
      deleteConfirmDescription:
        'Jeni i sigurt që dëshironi të fshini këtë takim? Ky veprim nuk mund të kthehet.',
      confirmDelete: 'Po, Fshije',
      statusScheduled: 'Planifikuar',
      statusCompleted: 'Përfunduar',
      statusCancelled: 'Anuluar',
    },
    clients: {
      title: 'Klientët e Mi',
      searchPlaceholder: 'Kërko klientë...',
      noClients: 'Nuk u gjetën klientë',
      noSearchResults: 'Asnjë klient nuk përputhet me kërkimin tuaj',
      schedule: 'Planifiko',
      upcomingAppointments: 'Takimet e Ardhshme',
      noUpcomingAppointments: 'Nuk ka takime të ardhshme',
      moreAppointments: '+{{count}} më shumë',
    },
    profile: {
      title: 'Profili i Trajnerit',
      personalInfo: 'Informacioni Personal',
      personalInfoDescription:
        'Përditëso informacionin tënd personal dhe biografinë',
      name: 'Emri',
      email: 'Email',
      phone: 'Telefoni',
      specialization: 'Specializimi',
      bio: 'Biografia',
      save: 'Ruaj Ndryshimet',
      availability: 'Disponueshmëria',
      availabilityDescription:
        'Vendos orarin tënd të punës dhe disponueshmërinë',
      workdays: 'Ditët e Punës',
      workHours: 'Orari i Punës',
      saveAvailability: 'Ruaj Disponueshmërinë',
    },
  },
  receptionView: {
    title: 'Paneli i Recepsionit',
    users: 'Përdoruesit',
    plans: 'Planet',
    checkIn: 'Hyrje/Dalje',
    payments: 'Pagesat',
    subscriptions: 'Abonimet',
  },
  financialReports: {
    title: 'Raportet Financiare',
    description: 'Shiko dhe analizo të dhënat financiare për palestrën tënde',
    totalRevenue: 'Të Ardhurat Totale',
    netProfit: 'Fitimi Neto',
    activeSubscriptions: 'Abonimet Aktive',
    avgRevenuePerUser: 'Të Ardhurat Mesatare për Përdorues',
    fromLastMonth: 'nga muaji i kaluar',
    revenueOverTime: 'Të ardhurat, shpenzimet dhe fitimi mujor',
    expenseBreakdown: 'Ndarja e Shpenzimeve',
    expenseBreakdownDescription: 'Shpërndarja e shpenzimeve sipas kategorisë',
    subscriptionRevenue: 'Të Ardhurat nga Abonimet',
    subscriptionRevenueDescription:
      'Ndarja e të ardhurave sipas llojit të abonimit',
    paymentHistory: 'Historia e Pagesave',
    paymentHistoryDescription: 'Transaksionet e pagesave të fundit',
    subscriptionType: 'Lloji i Abonimit',
    subscribers: 'Abonentët',
    revenue: 'Të Ardhurat',
    expenses: 'Shpenzimet',
    profit: 'Fitimi',
    averageRevenue: 'Të Ardhurat Mesatare',
    total: 'Totali',
    paymentId: 'ID e Transaksionit',
    date: 'Data',
    user: 'Përdoruesi',
    method: 'Metoda',
    status: 'Statusi',
    amount: 'Shuma',
    searchPayments: 'Kërko pagesat...',
    export: 'Eksporto',
    noPaymentsFound: 'Nuk u gjetën pagesa',
    noExpenseData: 'Nuk ka të dhëna për shpenzimet',
    noRevenueData: 'Nuk ka të dhëna për të ardhurat',
    selectDateRange: 'Zgjidh intervalin e datave',
    allGyms: 'Të gjitha Palestrat',
    searchGym: 'Kërko palestër...',
    noGymFound: 'Nuk u gjet asnjë palestër',
    chartPlaceholder: 'Të dhënat e grafikut do të shfaqen këtu',
    financialOverview: 'Përmbledhje Financiare',
    financialOverviewDescription:
      'Treguesit kryesorë financiarë dhe të performancës',
    totalExpenses: 'Shpenzimet Totale',
    expenseCategories: {
      salaries: 'Pagat',
      rent: 'Qiraja',
      equipment: 'Pajisjet',
      utilities: 'Shërbimet',
      marketing: 'Marketingu',
    },
    subscriptionTypes: {
      basic: 'Bazik',
      premium: 'Premium',
      family: 'Familjar',
      corporate: 'Korporativ',
    },
    paymentStatus: {
      completed: 'Përfunduar',
      pending: 'Në pritje',
      failed: 'Dështuar',
    },
  },
  userNav: {
    profile: 'Profili',
    gymSettings: 'Cilësimet e palestrës',
    billing: 'Faturimi',
    settings: 'Cilësimet',
    logout: 'Dilni',
  },
} as const;

// Add these to your existing Albanian translations
export const apiMessages = {
  loading: 'Duke ngarkuar...',
  error: 'Ndodhi një gabim',
  success: 'Sukses',
  retry: 'Provo përsëri',
  noData: 'Nuk ka të dhëna',

  // User messages
  userCreated: 'Përdoruesi u krijua me sukses',
  userUpdated: 'Përdoruesi u përditësua me sukses',
  userDeleted: 'Përdoruesi u fshi me sukses',

  // Plan messages
  planCreated: 'Plani u krijua me sukses',
  planUpdated: 'Plani u përditësua me sukses',
  planDeleted: 'Plani u fshi me sukses',
  planAssigned: 'Plani u caktua me sukses',

  // Auth messages
  loginSuccess: 'Hyrje e suksesshme',
  loginError: 'Kredencialet e pavlefshme',
  sessionExpired: 'Sesioni juaj ka skaduar. Ju lutemi hyni përsëri.',
  unauthorized: 'Nuk jeni i autorizuar për të kryer këtë veprim',

  // Form messages
  required: 'Kjo fushë është e detyrueshme',
  invalidEmail: 'Ju lutemi shkruani një email të vlefshëm',
  passwordMismatch: 'Fjalëkalimet nuk përputhen',
  invalidDate: 'Ju lutemi shkruani një datë të vlefshme',
} as const;

// Tenant Signup Translations
const tenantSignupTranslations = {
  title: 'Filloni Biznesin Tuaj të Palestrës',
  subtitle:
    'Krijoni platformën tuaj të menaxhimit të palestrës brenda minutash',
  steps: {
    businessDetails: 'Detajet e Biznesit',
    payment: 'Pagesa',
  },
  businessDetails: 'Detajet e Biznesit',
  businessDetailsDesc: 'Na tregoni për biznesin tuaj të palestrës',
  businessName: 'Emri i Biznesit',
  businessNamePlaceholder: 'FitZone Gym',
  subdomain: 'Subdomaini Juaj',
  subdomainTaken: 'Ky subdomain është i zënë',
  subdomainNotAvailable: 'Ju lutemi zgjidhni një subdomain të disponueshëm',
  // Branding
  branding: 'Personalizimi i Markës',
  brandingDesc: 'Personalizoni pamjen e palestrës suaj',
  brandColor: 'Ngjyra e Markës',
  brandColorHint: 'Kjo do të jetë ngjyra juaj kryesore',
  primaryColor: 'Ngjyra Kryesore',
  logo: 'Logo',
  optional: 'opsionale',
  uploadLogo: 'Ngarko logon',
  logoHint: 'PNG, JPG, SVG, WebP ose GIF (max 2MB)',
  invalidLogoType: 'Ju lutemi ngarkoni një skedar PNG, JPG, SVG, WebP, ose GIF',
  logoTooLarge: 'Madhësia e skedarit duhet të jetë më pak se 2MB',
  brandingPreview: 'Parashikim i Markës',
  yourGym: 'Palestra Juaj',
  sampleButton: 'Buton Shembull',
  // Owner
  ownerDetails: 'Llogaria e Pronarit',
  ownerName: 'Emri i Plotë',
  ownerNamePlaceholder: 'Filan Fisteku',
  ownerEmail: 'Adresa Email',
  password: 'Fjalëkalimi',
  confirmPassword: 'Konfirmo Fjalëkalimin',
  selectPlan: 'Zgjidhni Planin Tuaj',
  numberOfGyms: 'Numri i Palestrave',
  selectGyms: 'Zgjidhni numrin e palestrave',
  gym: 'palestër',
  gyms: 'palestra',
  upToGyms: 'Deri në {{count}} palestra',
  month: 'muaj',
  orderSummary: 'Përmbledhja e Porosisë',
  plan: 'Plani',
  pricePerGym: 'Çmimi për Palestër',
  total: 'Totali',
  continueToPayment: 'Vazhdo në Pagesë',
  confirmAndPay: 'Konfirmo & Paguaj',
  reviewDetails: 'Ju lutemi rishikoni detajet para se të vazhdoni në pagesë',
  monthlyTotal: 'Totali Mujor',
  back: 'Kthehu',
  processing: 'Duke përpunuar...',
  proceedToPayment: 'Vazhdo në Pagesë',
  stripeRedirect:
    'Do të ridrejtoheni në Stripe për të përfunduar pagesën në mënyrë të sigurt',
  alreadyHaveAccount: 'Keni tashmë një llogari?',
  signIn: 'Hyni',
  error: 'Gabim',
  unexpectedError: 'Ndodhi një gabim i papritur',
  securePayment: 'Pagesë e sigurt përmes Stripe',
  instantSetup: 'Konfigurim i menjëhershëm pas pagesës',
  dedicatedDatabase: 'Databazë e dedikuar për të dhënat tuaja',
  customSubdomain: 'Subdomain i personalizuar i përfshirë',
  success: {
    title: 'Mirë se vini në Gym!',
    subtitle: 'Platforma juaj e menaxhimit të palestrës është gati',
    whatSetUp: 'Çfarë kemi konfiguruar për ju',
    databaseCreated: 'Databaza e dedikuar u krijua',
    adminAccountCreated: 'Llogaria e administratorit u krijua',
    subdomainConfigured: 'Subdomaini i personalizuar u konfigurua',
    subscriptionActivated: 'Abonimi u aktivizua',
    loginDetails: 'Detajet Tuaja të Hyrjes',
    yourDashboard: 'Paneli Juaj',
    useCredentials:
      'Përdorni emailin dhe fjalëkalimin që keni dhënë gjatë regjistrimit',
    emailSent:
      'Një email konfirmimi është dërguar në adresën tuaj me këto detaje.',
    goToDashboard: 'Shko te Paneli',
    redirecting: 'Duke u ridrejtuar në {{seconds}} sekonda...',
  },

  health: {
    tab: 'Shëndeti',
    dietPlans: 'Planet e Dietës',
    weight: 'Pesha',
    fasting: 'Agjërimi',
    foodIntake: 'Marrja e Ushqimit',
    currentWeight: 'Pesha Aktuale',
    targetWeight: 'Pesha e Synuar',
    goalProgress: 'Progresi i Qëllimit',
    dailyCalories: 'Kaloritë Ditore',
    activePlans: 'Planet Aktive',
    weightProgress: 'Progresi i Peshës',
    weightHistory: 'Historia e Peshës',
    logWeight: 'Regjistro Peshën',
    noWeightData: 'Nuk ka të dhëna peshe ende. Regjistroni hyrjen e parë.',
    totalLogs: 'Totali i Regjistrimeve',
    entries: 'regjistrime',
    toLose: 'për të humbur',
    toGain: 'për të fituar',
    weightNotesPlaceholder: 'Pesha në mëngjes, pas stërvitjes...',
    currentStreak: 'Seria Aktuale',
    longestFast: 'Agjërimi Më i Gjatë',
    totalFasts: 'Totali i Agjërimeve',
    startFast: 'Fillo Agjërimin',
    endFast: 'Përfundo Agjërimin',
    fastingHistory: 'Historia e Agjërimit',
    fastingType: 'Lloji i Agjërimit',
    durationHours: 'Kohëzgjatja (orë)',
    fastNotesPlaceholder: 'Si shkoi?',
    completed: 'Përfunduar',
    incomplete: 'Jo i plotë',
    type: 'Lloji',
    duration: 'Kohëzgjatja',
    noFastingData: 'Nuk ka rekorde agjërimi ende. Filloni agjërimin e parë!',
    fastInProgress: 'agjërim në vazhdim',
    started: 'Filloi',
    target: 'Synimi',
    recentAverage: 'Mesatarja 7-Ditore',
    calories: 'Kalori',
    protein: 'Proteina',
    carbs: 'Karbohidrate',
    fat: 'Yndyrë',
    noIntakeData: 'Nuk u gjetën rekorde të marrjes ushqimore.',
    followingPlan: 'Duke Ndjekur Planin',
    lastChange: 'Ndryshimi i Fundit',
    sinceLastLog: 'nga regjistrimi i fundit',
  },
};

// Subscription Management Translations
const subscriptionTranslations = {
  title: 'Abonimi',
  description: 'Menaxhoni abonimin dhe faturimin tuaj të Gym',
  refresh: 'Rifresko',
  status: {
    label: 'Statusi',
    active: 'Aktiv',
    trialing: 'Provë',
    pastDue: 'I Vonuar',
    canceled: 'I Anuluar',
    incomplete: 'I Paplotë',
  },
  plan: 'Plani',
  gymLimit: 'Përdorimi i Palestrave',
  gyms: 'palestra',
  gym: 'palestër',
  nextBilling: 'Faturimi i Ardhshëm',
  monthlyTotal: 'Totali Mujor',
  month: 'muaj',
  changeGyms: 'Ndrysho Numrin e Palestrave',
  manageBilling: 'Menaxho Faturimin',
  cancel: 'Anulo Abonimin',
  changeGymsTitle: 'Ndrysho Numrin e Palestrave',
  changeGymsDescription:
    'Rregulloni numrin e palestrave të përfshira në abonimin tuaj',
  newGymCount: 'Numri i Ri i Palestrave',
  currentPlan: 'Aktual',
  newPlan: 'I Ri',
  upgrading: 'Duke përmirësuar - do të aplikohen tarifa proporcionale',
  downgrading:
    'Duke ulur - ndryshimet aplikohen në ciklin e ardhshëm të faturimit',
  confirmChange: 'Konfirmo Ndryshimin',
  cancelTitle: 'Anulo Abonimin',
  cancelDescription: 'Jeni i sigurt që dëshironi të anuloni abonimin tuaj?',
  cancelWarning:
    'Anulimi i abonimit do të çaktivizojë qasjen në platformën tuaj të menaxhimit të palestrës.',
  cancelReason: 'Arsyeja e anulimit (opsionale)',
  cancelReasonPlaceholder: 'Na tregoni pse po largoheni...',
  cancelImmediately: 'Anulo menjëherë (humb qasjen tani)',
  cancelAtPeriodEndNote: 'Abonimi juaj do të mbetet aktiv deri më {{date}}',
  keepSubscription: 'Mbaj Abonimin',
  confirmCancel: 'Po, Anulo',
  success: 'Sukses',
  error: 'Gabim',
  updateSuccess: 'Abonimi u përditësua me sukses',
  updateError: 'Dështoi përditësimi i abonimit',
  canceledImmediately: 'Abonimi u anulua menjëherë',
  canceledAtPeriodEnd:
    'Abonimi do të anulohet në fund të periudhës së faturimit',
  cancelError: 'Dështoi anulimi i abonimit',
  reactivate: 'Riaktivizo',
  reactivated: 'Abonimi u riaktivizua me sukses',
  reactivateError: 'Dështoi riaktivizimi i abonimit',
  portalError: 'Dështoi hapja e portalit të faturimit',
  pastDueWarning:
    'Pagesa juaj është e vonuar. Ju lutemi përditësoni metodën e pagesës për të shmangur ndërprerjen e shërbimit.',
  updatePayment: 'Përditëso Metodën e Pagesës',
  cancelScheduled: 'Abonimi juaj është planifikuar të anulohet më {{date}}.',
  loadError: 'Dështoi ngarkimi i detajeve të abonimit',
};

// Billing Page Translations
const billingTranslations = {
  title: 'Faturimi & Abonimi',
  description: 'Menaxhoni abonimin, metodat e pagesës dhe faturat tuaja',
};

// Add the financial reports translations to the Albanian translations
const sq = {
  ...sqTranslations,
  apiMessages: apiMessages,
  tenantSignup: tenantSignupTranslations,
  subscription: subscriptionTranslations,
  billing: billingTranslations,
};

export default sq;
